// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__7q6nH","error":"Textarea_error__mk_jp","readonly":"Textarea_readonly__38b53","disabled":"Textarea_disabled__3otwb"};